<script setup lang="ts">
import { configDeliveryZones } from '@/storage/setting/configDeliveryZones'
import { toggleShowDeliveryZones } from '@/utils/order/toggleShowDeliveryZones'
import { ref } from 'vue'

const dropdownDeliveryZone = ref(configDeliveryZones.value.map(() => false))

function toggleDeliveryZone(index: any) {
    dropdownDeliveryZone.value[index] = !dropdownDeliveryZone.value[index]
}
</script>

<template>
    <section class="section-modal-delivery-zone-happy">
        <section
            class="section-modal-overlay-delivery-zone-happy"
            @click="toggleShowDeliveryZones()"
        ></section>

        <section class="section-modal-delivery-zone-content-happy">
            <div class="div-header-modal-delivery-zone-happy">
                <h3 class="header-modal-delivery-zone-happy">Zones de livraison</h3>
            </div>
            <div class="div-content-modal-delivery-zone-happy">
                <ul
                    class="ul-delivery-zone-happy"
                    v-for="(zone, index) in configDeliveryZones"
                    :key="index"
                >
                    <li class="li-delivery-zone-happy" @click="toggleDeliveryZone(index)">
                        {{ zone.city }}
                    </li>
                    <transition
                        name="delivery-zone"
                        enter-active-class="transition-all duration-300 ease-in-out"
                        enter-from-class="max-h-0 opacity-0"
                        enter-to-class="max-h-96 opacity-100"
                        leave-active-class="transition-all duration-300 ease-in-out"
                        leave-from-class="max-h-96 opacity-100"
                        leave-to-class="max-h-0 opacity-0"
                    >
                        <div
                            v-if="dropdownDeliveryZone[index]"
                            class="div-dropdown-content-happy"
                        >
                            <p>- Frais de livraison : {{ Number(zone.price) }}</p>
                            <p>
                                - Montant minimum du panier:
                                {{ Number(zone.minimum_price).toFixed(2) }}€
                            </p>
                            <p v-if="Number(zone.free_price).toFixed(2) !== '0.00'">
                                - Frais de livraison gratuite à partir de:
                                {{ Number(zone.free_price).toFixed(2) }} €
                            </p>
                        </div>
                    </transition>
                </ul>
            </div>
        </section>
    </section>
</template>

<style scoped>
.section-modal-delivery-zone-happy {
    @apply fixed top-0 w-full h-full z-30 flex items-center justify-center;
}

.section-modal-overlay-delivery-zone-happy {
    @apply w-full h-full happy-light:bg-text-dark-happy-light opacity-50 happy-dark:bg-bg-happy-light;
}

/* .section-modal-delivery-zone-header {
    Styles for the header section
}
*/

.section-modal-delivery-zone-content-happy {
    @apply z-30 flex flex-col absolute border-2 rounded-lg max-w-[28rem] border-border-red-happy-light w-full happy-light:bg-bg-happy-light happy-dark:bg-text-dark-happy-light;
}
.div-header-modal-delivery-zone-happy {
    @apply flex p-3 bg-border-gray-happy-light rounded-t-md;
}
.header-modal-delivery-zone-happy {
    @apply uppercase font-semibold  text-text-dark-happy-light;
}
.div-content-modal-delivery-zone-happy {
    @apply pl-7 pr-3 py-2 max-h-[32rem]  w-full overflow-y-auto flex  flex-wrap;
}

.ul-delivery-zone-happy {
    @apply flex flex-col flex-wrap  w-full;
}

.li-delivery-zone-happy {
    @apply list-disc  w-full;
}
.li-delivery-zone-happy:active {
    @apply text-header-red-happy font-semibold underline;
}
.div-dropdown-content-happy {
    @apply w-full;
}
.div-dropdown-content-happy:active {
    @apply text-border-red-happy-light flex-wrap flex flex-col;
}

@media (hover: hover) {
    .li-delivery-zone-happy:hover {
        @apply text-header-red-happy font-semibold underline;
    }
    .div-dropdown-content-happy:hover {
        @apply text-border-red-happy-light;
    }
}
</style>
